<!-- Scrollable Question Content -->
<div
  class="question-container animate-in fade-in slide-in-from-right-4 duration-300 pb-24"
>
  <!-- Question Text -->
  <h2 class="text-lg font-bold text-gray-900 mb-8 leading-relaxed">
    {{ question?.questionText }}
  </h2>

  <!-- Answer Area -->
  <div class="answer-area mb-8">
    @switch (question?.type) {
      <!-- Multiple Choice -->
      @case (QuestionType.MULTIPLE_CHOICE) {
        <div class="space-y-3">
          @for (option of question?.options; track option.id) {
            <button
              type="button"
              (click)="onOptionSelect(option.id)"
              class="w-full p-4 rounded-xl border-2 text-left transition-all duration-200 flex items-center gap-3"
              [class.border-gray-200]="selectedOptionId !== option.id"
              [class.bg-white]="selectedOptionId !== option.id"
              [class.hover:border-gray-300]="selectedOptionId !== option.id"
              [class.border-green-500]="selectedOptionId === option.id"
              [class.bg-green-50]="selectedOptionId === option.id"
            >
              <div
                class="w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all duration-200"
                [class.border-gray-300]="selectedOptionId !== option.id"
                [class.border-green-500]="selectedOptionId === option.id"
                [class.bg-green-500]="selectedOptionId === option.id"
              >
                @if (selectedOptionId === option.id) {
                  <div class="w-2 h-2 rounded-full bg-white"></div>
                }
              </div>
              <span
                class="text-gray-700"
                [class.font-medium]="selectedOptionId === option.id"
              >
                {{ option.text }}
              </span>
            </button>
          }
        </div>
      }

      <!-- Short Answer -->
      @case (QuestionType.SHORT_ANSWER) {
        <div class="relative">
          <textarea
            #textareaEl
            [value]="textAnswer"
            (input)="onTextChange($event)"
            placeholder="Type your answer here..."
            rows="4"
            class="w-full p-4 rounded-xl border-2 border-gray-200 bg-white resize-none overflow-hidden transition-all duration-200 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500/20"
          ></textarea>
          <div class="absolute bottom-3 right-3 text-sm text-gray-400">
            {{ textAnswer.length }} chars
          </div>
        </div>
      }

      <!-- Essay -->
      @case (QuestionType.ESSAY) {
        <div class="relative">
          <textarea
            #textareaEl
            [value]="textAnswer"
            (input)="onTextChange($event)"
            placeholder="Type your answer here..."
            rows="8"
            class="w-full p-4 rounded-xl border-2 border-gray-200 bg-white resize-none overflow-hidden transition-all duration-200 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500/20"
          ></textarea>
          <div class="absolute bottom-3 right-3 text-sm text-gray-400">
            {{ textAnswer.length }} chars
          </div>
        </div>
      }
    }
  </div>
</div>

<!-- Fixed Bottom Footer with Navigation Buttons -->
<footer
  class="fixed bottom-0 left-0 right-0 z-50 bg-[#FFFDF5]/95 backdrop-blur-sm border-t border-gray-100"
>
  <div class="max-w-[500px] mx-auto px-4 py-3 flex gap-3">
    <!-- Back Button (only if not first question) -->
    @if (!isFirstQuestion) {
      <button
        type="button"
        (click)="onPrevious()"
        class="flex-1 py-3 px-4 rounded-xl font-semibold text-gray-700 bg-gray-100 flex items-center justify-center gap-2 transition-all duration-200 hover:bg-gray-200 active:scale-[0.98]"
      >
        <lucide-icon [img]="icons.ArrowLeft" class="w-5 h-5"></lucide-icon>
        <span>Back</span>
      </button>
    }

    <!-- Next/Submit Button -->
    @if (isLastQuestion) {
      <button
        type="button"
        (click)="onSubmit()"
        [disabled]="isSubmitting"
        class="flex-1 py-3 px-4 rounded-xl font-semibold text-white flex items-center justify-center gap-2 transition-all duration-200 hover:opacity-90 active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
        [style.background-color]="themeColor"
      >
        @if (isSubmitting) {
          <div
            class="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"
          ></div>
          <span>Submitting...</span>
        } @else {
          <span>Submit</span>
          <lucide-icon [img]="icons.Send" class="w-5 h-5"></lucide-icon>
        }
      </button>
    } @else {
      <button
        type="button"
        (click)="onNext()"
        class="flex-1 py-3 px-4 rounded-xl font-semibold text-white flex items-center justify-center gap-2 transition-all duration-200 hover:opacity-90 active:scale-[0.98] shadow-lg"
        [style.background-color]="themeColor"
      >
        <span>{{ isFirstQuestion ? 'Next Question' : 'Next' }}</span>
        <lucide-icon [img]="icons.ArrowRight" class="w-5 h-5"></lucide-icon>
      </button>
    }
  </div>
</footer>
